import { Component, Vue, Watch } from 'vue-property-decorator';
import cookie from '@/assets/js/cookie/cookie';
import check from '@/assets/js/check/check';
import compress from '@/assets/js/compress/compress';
import config from '../../../api/params.config';
import { ImagePreview } from 'vant';

declare const wx: any;

@Component({})
export default class Prove extends Vue {
    private $api: any;
    private isMobile: boolean = true; // 是否在移动端打开
    private noticeShow: boolean = true; // 展示拍照须知
    private infoShow: boolean = false;
    private showChiefPopup: boolean = false; // 是否展示搜索选择弹窗
    private chiefIsEmpty: boolean = true; // 搜索结果是否为空
    private searchChiefStr: string = ''; // 搜索string
    private chiefList: any = []; // 总工信息List
    private selectedChiefRadio: string = '';
    private chiefInfo: any = {}; // 选中总工的信息
    private IDCardList: any = []; // 已上传的身份证正面照
    private IDCardBackList: any = []; // 已上传的身份证反面照
    private LiveList: any = []; // 已上传的生活照
    private imgIDCode: string = ''; // 身份证照片中解析出的身份证号
    private ImgStr: any = []; // 图片Base64
    private limitImgSize: any = 5 * 1024 * 1024; // 限制上传图片大小
    private IDCardInfo: any = {}; // 正面身份证Ali返回的Url和Id
    private IDCardBackInfo: any = {}; // 反面身份证Ali返回的Url和Id
    private LiveInfo: any = {}; // 生活照Ali返回的Url和Id   
    private userName: string = ''; // 姓名
    private userIDCode: string = ''; // 身份证号
    private IDCodeError: string = ''; // 身份证号错误信息
    private userPhone: string = ''; // 手机号
    private phoneError: string = ''; // 手机号错误信息
    private checkCode: string = ''; // 短信验证码
    private countDownTime: any = 120000; // 短信验证码倒计时
    private countDownShow: boolean = false; // 是否显示倒计时
    private checkCodeDisabled: boolean = false; // 验证码Disabled
    private fileList: any = []; // 文件保存信息
    private isDisabled: boolean = true;
    private IDCodeDisabled: boolean = true; // 身份证号验证
    private phoneDisabled: boolean = true; // 手机号验证
    private reactURL: any = ''; // 保存后跳转url
    public mounted() {
        this.reactURL = this.$route.query.reactURL;
        this.init();
    }
    // 初始化
    private async init() {
        // 是否在移动端打开
        function CheckMobile() {
            const userAgentInfo = navigator.userAgent;
            const Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'];
            for (const i of Agents) {
                if (userAgentInfo.indexOf(i) >= 0) {
                    return true;
                }
            }
            return false;
        }
        if (CheckMobile()) {
            this.isMobile = true;
            this.$toast.loading({
                duration: 0,       // 持续展示toast
                forbidClick: true, // 禁用背景点击
                loadingType: 'spinner',
                message: '正在加载...',
            });
        } else {
            this.isMobile = false;
            return;
        }
        this.$toast.clear();
        this.infoShow = true;
    }
    // 搜索总工
    private async searchChiefs(entity: any) {
        if (check.checkNull(entity)) {
            this.chiefList = [];
            const model = {
                name: entity,
            };
            // 获取总工信息
            const chiefData = await this.$api.httpGet('InterFace/UworkFaceInfo/GetUworkInfo', model);
            if (chiefData.Success) {
                if (chiefData.Data && chiefData.Data.length > 0) {
                    this.chiefList = chiefData.Data;
                    this.chiefIsEmpty = false;
                } else {
                    this.chiefIsEmpty = true;
                }            
            } else {
                this.$dialog.alert({
                    title: '错误',
                    message: chiefData.AllMessages,
                });
            }
        }
    }
    // 选择总工
    private async selectedChief(entity: any) {
        if (check.checkNull(entity)) {
            this.chiefInfo.label = entity.UserName + '-' + entity.ManagerName;
            this.chiefInfo.organizationUserName = entity.UserName;
            this.chiefInfo.organizationCode = entity.Code;
            this.showChiefPopup = false; // 关闭弹窗
            this.searchChiefStr = ''; // 清空数据
            this.chiefList = []; // 清空数据
            this.chiefIsEmpty = true; // 清空数据
        }
    }
    // 清除总工信息
    private async clearChief() {
        this.chiefInfo = {};
    }
    // 示例图片预览
    private async preview(index: any) {
        ImagePreview({
            images: [
                'https://ehrhz.oss-cn-hangzhou.aliyuncs.com/IDCard_example.png',
                'https://ehrhz.oss-cn-hangzhou.aliyuncs.com/2d241baf-2cd4-4afd-be5e-ad5bf4460490.png',
                'https://ehrhz.oss-cn-hangzhou.aliyuncs.com/live_example.png',
                ],
            startPosition: index,
        });
    }    
    // 上传身份证正面照片
    private async getIDCard(IDCard: any) {
        this.$toast.loading({
            duration: 0,       // 持续展示 toast
            forbidClick: true, // 禁用背景点击
            loadingType: 'spinner',
            message: '正在检测，请稍等...',
        });
        if (IDCard.file.size > this.limitImgSize) {
            // 进行身份证正面照压缩
            let self = this;
            const img = new Image();
            img.src = IDCard.content;
            img.onload = () => {
                // 压缩
                let data = compress.img(img, 0.6);
                // 检测、上传
                self.IDCheck(data, IDCard);
            };
        } else {
            this.IDCheck(IDCard.content, IDCard);
        }
    }
    // 身份证检测
    private async IDCheck(imgStr: any, IDCard: any) {
        // Base64截去前缀
        this.ImgStr.IDCard = imgStr.substr(imgStr.lastIndexOf(',') + 1);
        // Base64转换File
        IDCard.file = compress.Base64ToFile(imgStr, IDCard.file.name);
        this.ImgStr.IDCardSize = IDCard.file.size; // 图片大小，单位字节
        // 限制大小
        if (this.ImgStr.IDCardSize > this.limitImgSize) {
            this.isDisabled = true;
            this.IDCardList = [];
            this.$dialog.alert({
                title: '错误',
                message: '照片过大，请重新上传小于5M的照片。',
            });
            return;
        }
        // 身份证检测
        const model = {
            base64ImgStr: this.ImgStr.IDCard,
            idCardSide: 'front',
        };
        const checkResult = await this.$api.httpPost('BaiDuApi/BaiDuFace/CheckIdCard', model);
        if (checkResult.Success) {
            const checkInfo = JSON.parse(checkResult.Data);
            this.imgIDCode = checkInfo.words_result.公民身份号码.words;
            this.userName = checkInfo.words_result.姓名.words;
            this.userIDCode = this.imgIDCode;
            // 若需要填写身份证号，验证身份证号与身份证照片是否相符
            if (this.userIDCode !== '' && this.imgIDCode !== this.userIDCode) {
                this.isDisabled = true;
                this.$toast.clear();
                this.$dialog.alert({
                    title: '错误',
                    message: '身份证号与身份证照片不符，请重新输入身份证号或重新上传身份证正面照片。',
                });
                return;
            }
            if (checkInfo.image_status === 'normal') {
                // 身份证上传阿里云
                const fileModel = IDCard.file;
                const formData = new FormData();
                formData.append('files', fileModel, fileModel.name);
                const uploadResult = await this.$api.httpPost('Announcement/CommonMethod/AddEnclosureAliyun', formData);
                if (uploadResult.Success) {
                    this.$toast.clear();
                    this.IDCardInfo.fileUrl = uploadResult.Data.Url;
                    this.IDCardInfo.resourceItemId = uploadResult.Data.Id;
                    this.IDCardInfo.fileSource = 1;
                    this.$toast.success('上传成功');
                } else {
                    this.isDisabled = true;
                    this.$toast.clear();
                    this.$dialog.alert({
                        title: '错误',
                        message: uploadResult.AllMessages,
                    });
                }
            } else if (checkInfo.image_status === 'reversed_side') {
                this.isDisabled = true;
                this.IDCardList = [];
                this.$toast.clear();
                this.$dialog.alert({
                    title: '错误',
                    message: '身份证正反面颠倒，请重新上传身份证正面照片。',
                });
            } else if (checkInfo.image_status === 'non_idcard') {
                this.isDisabled = true;
                this.IDCardList = [];
                this.$toast.clear();
                this.$dialog.alert({
                    title: '错误',
                    message: '上传的图片不是身份证照片，请重新上传身份证正面照片。',
                });
            } else if (checkInfo.image_status === 'blurred') {
                this.isDisabled = true;
                this.IDCardList = [];
                this.$toast.clear();
                this.$dialog.alert({
                    title: '错误',
                    message: '身份证模糊，请重新上传身份证正面照片。',
                });
            } else if (checkInfo.image_status === 'other_type_card') {
                this.isDisabled = true;
                this.IDCardList = [];
                this.$toast.clear();
                this.$dialog.alert({
                    title: '错误',
                    message: '当前图片是其他类型证照，请重新上传身份证正面照片。',
                });
            } else if (checkInfo.image_status === 'over_exposure') {
                this.isDisabled = true;
                this.IDCardList = [];
                this.$toast.clear();
                this.$dialog.alert({
                    title: '错误',
                    message: '身份证关键字段反光或过曝，请重新上传身份证正面照片。',
                });
            } else if (checkInfo.image_status === 'over_dark') {
                this.isDisabled = true;
                this.IDCardList = [];
                this.$toast.clear();
                this.$dialog.alert({
                    title: '错误',
                    message: '身份证欠曝，请重新上传身份证正面照片。',
                });
            } else {
                this.isDisabled = true;
                this.IDCardList = [];
                this.$toast.clear();
                this.$dialog.alert({
                    title: '错误',
                    message: '身份证检测失败，请重新上传身份证正面照片。',
                });
            }
        } else {
            this.isDisabled = true;
            this.IDCardList = [];
            this.$toast.clear();
            let errorMessage = checkResult.AllMessages;
            if (check.checkNull(checkResult.Data)) {
                const error = JSON.parse(checkResult.Data);
                if (error.error_code === 216201) {
                    errorMessage = '身份证识别失败！照片格式错误';
                }
            }
            this.$dialog.alert({
                title: '错误',
                message: errorMessage,
            });
        }
    }
    // 上传身份证反面照片
    private async getIDCardBack(IDCardBack: any) {
        this.$toast.loading({
            duration: 0,       // 持续展示 toast
            forbidClick: true, // 禁用背景点击
            loadingType: 'spinner',
            message: '正在检测，请稍等...',
        });
        if (IDCardBack.file.size > this.limitImgSize) {
            // 进行身份证正面照压缩
            let self = this;
            const img = new Image();
            img.src = IDCardBack.content;
            img.onload = () => {
                // 压缩
                let data = compress.img(img, 0.6);
                // 检测、上传
                self.IDCardBackCheck(data, IDCardBack);
            };
        } else {
            this.IDCardBackCheck(IDCardBack.content, IDCardBack);
        }
        
    }
    // 身份证检测
    private async IDCardBackCheck(imgStr: any, IDCardBack: any) {
        // Base64截去前缀
        this.ImgStr.IDCardBack = imgStr.substr(imgStr.lastIndexOf(',') + 1);
        // Base64转换File
        IDCardBack.file = compress.Base64ToFile(imgStr, IDCardBack.file.name);
        this.ImgStr.IDCardBackSize = IDCardBack.file.size; // 图片大小，单位字节
        // 限制大小
        if (this.ImgStr.IDCardBackSize > this.limitImgSize) {
            this.isDisabled = true;
            this.IDCardBackList = [];
            this.$dialog.alert({
                title: '错误',
                message: '照片过大，请重新上传小于5M的照片。',
            });
            return;
        }
        // 身份证背面检测
        const model = {
            base64ImgStr: this.ImgStr.IDCardBack,
            idCardSide: 'back',
        };
        const checkResult = await this.$api.httpPost('BaiDuApi/BaiDuFace/CheckIdCard', model);
        if (checkResult.Success) {
            const checkInfo = JSON.parse(checkResult.Data);
            if (checkInfo.image_status === 'normal') {
                // 身份证反面照片上传阿里云
                const fileModel = IDCardBack.file;
                const formData = new FormData();
                formData.append('files', fileModel, fileModel.name);
                const uploadResult = await this.$api.httpPost('Announcement/CommonMethod/AddEnclosureAliyun', formData);
                if (uploadResult.Success) {
                    this.$toast.clear();
                    this.IDCardBackInfo.fileUrl = uploadResult.Data.Url;
                    this.IDCardBackInfo.resourceItemId = uploadResult.Data.Id;
                    this.IDCardBackInfo.fileSource = 1;
                    this.$toast.success('上传成功');
                } else {
                    this.isDisabled = true;
                    this.$toast.clear();
                    this.$dialog.alert({
                        title: '错误',
                        message: uploadResult.AllMessages,
                    });
                }
            } else if (checkInfo.image_status === 'reversed_side') {
                this.isDisabled = true;
                this.IDCardBackList = [];
                this.$toast.clear();
                this.$dialog.alert({
                    title: '错误',
                    message: '身份证正反面颠倒，请重新上传身份证反面照片。',
                });
            } else if (checkInfo.image_status === 'non_idcard') {
                this.isDisabled = true;
                this.IDCardBackList = [];
                this.$toast.clear();
                this.$dialog.alert({
                    title: '错误',
                    message: '上传的图片不是身份证照片，请重新上传身份证反面照片。',
                });
            } else if (checkInfo.image_status === 'blurred') {
                this.isDisabled = true;
                this.IDCardBackList = [];
                this.$toast.clear();
                this.$dialog.alert({
                    title: '错误',
                    message: '身份证模糊，请重新上传身份证反面照片。',
                });
            } else if (checkInfo.image_status === 'other_type_card') {
                this.isDisabled = true;
                this.IDCardBackList = [];
                this.$toast.clear();
                this.$dialog.alert({
                    title: '错误',
                    message: '当前图片是其他类型证照，请重新上传身份证反面照片。',
                });
            } else if (checkInfo.image_status === 'over_exposure') {
                this.isDisabled = true;
                this.IDCardBackList = [];
                this.$toast.clear();
                this.$dialog.alert({
                    title: '错误',
                    message: '身份证关键字段反光或过曝，请重新上传身份证反面照片。',
                });
            } else if (checkInfo.image_status === 'over_dark') {
                this.isDisabled = true;
                this.IDCardBackList = [];
                this.$toast.clear();
                this.$dialog.alert({
                    title: '错误',
                    message: '身份证欠曝，请重新上传身份证反面照片。',
                });
            } else {
                this.isDisabled = true;
                this.IDCardBackList = [];
                this.$toast.clear();
                this.$dialog.alert({
                    title: '错误',
                    message: '身份证检测失败，请重新上传身份证反面照片。',
                });
            }
        } else {
            this.isDisabled = true;
            this.IDCardBackList = [];
            this.$toast.clear();
            let errorMessage = checkResult.AllMessages;
            if (check.checkNull(checkResult.Data)) {
                const error = JSON.parse(checkResult.Data);
                if (error.error_code === 216201) {
                    errorMessage = '身份证识别失败！照片格式错误';
                }
            }
            this.$dialog.alert({
                title: '错误',
                message: errorMessage,
            });
        }
    }
    // 上传生活照
    private async getLive(live: any) {     
        this.$toast.loading({
            duration: 0,       // 持续展示 toast
            forbidClick: true, // 禁用背景点击
            loadingType: 'spinner',
            message: '正在检测，请稍等...',
        });
        if (live.file.size > this.limitImgSize) {
            // 进行生活照压缩
            let self = this;
            const img = new Image();
            img.src = live.content;
            img.onload = () => {
                // 压缩
                let data = compress.img(img, 0.6);
                // 检测、上传
                self.LiveCheck(data, live);
            };
        } else {
            this.LiveCheck(live.content, live);
        }
    }
    // 人脸检测
    private async LiveCheck(imgStr: any, live: any) {
        // Base64截去前缀
        this.ImgStr.live = imgStr.substr(imgStr.lastIndexOf(',') + 1);
        // Base64转换File
        live.file = compress.Base64ToFile(imgStr, live.file.name);
        this.ImgStr.liveSize = live.file.size; // 图片大小，单位字节
        if (this.ImgStr.liveSize > this.limitImgSize) {
            this.isDisabled = true;
            this.LiveList = [];
            this.$dialog.alert({
                title: '错误',
                message: '照片过大，请重新上传小于5M的照片。',
            });
            return;
        }
        // 生活照上传阿里云
        const fileModel = live.file;
        const formData = new FormData();
        formData.append('files', fileModel, fileModel.name);
        const uploadResult = await this.$api.httpPost('Announcement/CommonMethod/AddEnclosureAliyun', formData);
        if (uploadResult.Success) {
            this.LiveInfo.fileUrl = uploadResult.Data.Url;
            this.LiveInfo.resourceItemId = uploadResult.Data.Id;
            this.LiveInfo.fileSource = 3;
            // 人脸检测
            let imgUrlStr = this.LiveInfo.fileUrl;
            if (this.LiveInfo.fileUrl.indexOf('https:') === -1 && this.LiveInfo.fileUrl.indexOf('http:') === -1) {
                imgUrlStr = 'http:' + this.LiveInfo.fileUrl;
            }
            const model = {
                ImgStr: imgUrlStr,
                type: 'URL',
            };
            const checkResult = await this.$api.httpPost('BaiDuApi/BaiDuFace/CheckFaceImage', model);
            if (checkResult.Success) {
                if (checkResult.Data) {
                    if (checkResult.Data.result && checkResult.Data.result !== null) {
                        this.$toast.clear();
                        this.$toast.success('上传成功');
                    } else {
                        this.isDisabled = true;
                        this.LiveList = [];
                        this.$toast.clear();
                        this.$dialog.alert({
                            title: '错误',
                            message: checkResult.Data.error_msg,
                        });
                    }
                }
            } else {
                this.isDisabled = true;
                this.LiveList = [];
                this.$toast.clear();
                this.$dialog.alert({
                    title: '错误',
                    message: checkResult.AllMessages,
                });
            }
        } else {
            this.isDisabled = true;
            this.$toast.clear();
            this.$dialog.alert({
                title: '错误',
                message: uploadResult.AllMessages,
            });
        }
    }
    // 监听上传照片
    @Watch('IDCardList') private watchIDCardList() {
        if (this.IDCardList.length === 0 || this.IDCardList === '' || this.IDCardList === null || this.IDCardList === undefined || this.ImgStr.IDCardSize > this.limitImgSize) {
            this.isDisabled = true;
        } else {
            if (this.LiveList.length === 0 || this.ImgStr.liveSize > this.limitImgSize || this.IDCardBackList.length === 0 || this.ImgStr.IDCardBackSize > this.limitImgSize) {
                this.isDisabled = true;
            } else {
                this.isDisabled = false;
            }
        }
    }
    @Watch('IDCardBackList') private watchIDCardBackList() {
        if (this.IDCardBackList.length === 0 || this.IDCardBackList === '' || this.IDCardBackList === null || this.IDCardBackList === undefined || this.ImgStr.IDCardBackSize > this.limitImgSize) {
            this.isDisabled = true;
        } else {
            if (this.LiveList.length === 0 || this.ImgStr.liveSize > this.limitImgSize || this.IDCardList.length === 0 || this.ImgStr.IDCardSize > this.limitImgSize) {
                this.isDisabled = true;
            } else {
                this.isDisabled = false;
            }
        }
    }
    @Watch('LiveList') private watchLiveList() {
        if (this.LiveList.length === 0 || this.LiveList === '' || this.LiveList === null || this.LiveList === undefined || this.ImgStr.liveSize > this.limitImgSize) {
            this.isDisabled = true;
        } else {
            if (this.IDCardList.length === 0 || this.ImgStr.IDCardSize > this.limitImgSize || this.IDCardBackList.length === 0 || this.ImgStr.IDCardBackSize > this.limitImgSize) {
                this.isDisabled = true;
            } else {
                this.isDisabled = false;
            }
        }
    }
    // 输入手机号
    private checkPhone() {
        if (this.userPhone.length !== 0 && this.userPhone !== '') {
            // 验证手机号
            if (!check.checkPhone(this.userPhone)) {
                this.phoneDisabled = true;
                this.phoneError = '手机号码格式错误';
            } else {
                this.phoneDisabled = false;
                this.phoneError = '';
            }
        } else {
            this.phoneDisabled = true;
            this.phoneError = '';
        }
    }
    // 获取验证码
    private async getCheckCode() {
        this.countDownShow = true;
        this.checkCodeDisabled = true;
        // this.$refs.countDown.start();
        let num = '';
        for (let i = 0; i < 4; i++) {
            num += Math.floor(Math.random() * 9 + 1);
        }
        const sendModel = {
            Code: num,
            PhoneNumer: this.userPhone,
        };
        const sendData = await this.$api.httpPost('InterFace/UworkFaceInfo/SendCodeMsg', sendModel);
        if (sendData.Success) {
            if (sendData.Data) {
                this.$toast.success('发送成功');
            } else {
                this.$toast.fail('发送失败，请重试');
            }        
        } else {
            this.$dialog.alert({
                title: '错误',
                message: sendData.AllMessages,
            });
        }
    }
    // 结束验证码倒计时
    private finishCountDown() {
        this.countDownShow = false;
        this.checkCodeDisabled = false;
    }
    // 验证
    private async check() {
        this.countDownShow = false;
        this.checkCodeDisabled = true;
        if (this.IDCardList.length === 0) {
            this.$notify('请上传身份证正面照片');
            this.isDisabled = true;
        } else if (this.IDCardBackList.length === 0) {
            this.$notify('请上传身份证反面照片');
            this.isDisabled = true;
        } else if (this.LiveList.length === 0) {
            this.$notify('请拍照上传生活照');
            this.isDisabled = true;
        } else {
            this.checkCodeDisabled = false;
            this.isDisabled = false;            
            this.$toast.loading({
                duration: 0,       // 持续展示 toast
                forbidClick: true, // 禁用背景点击
                loadingType: 'spinner',
                message: '正在保存，请稍等...',
            });
            // 人脸对比
            const model = {
                idCardBase64ImgStr: this.ImgStr.IDCard,
                liveBase64ImgStr: this.ImgStr.live,
            };
            const contrastResult = await this.$api.httpPost('BaiDuApi/BaiDuFace/MatchFace', model);
            if (contrastResult.Success) {
                if (contrastResult.Data.result && contrastResult.Data.result !== null) {
                    // 验证手机号+验证码
                    const checkCodeModel = {
                        Code: this.checkCode,
                        PhoneNumer: this.userPhone,
                    };
                    const checkCodeResult = await this.$api.httpPost('InterFace/UworkFaceInfo/verifyCode', checkCodeModel);
                    if (checkCodeResult.Success) {
                        if (checkCodeResult.Data) {
                            this.save();
                        } else {
                            this.$toast.clear();
                            this.checkCodeDisabled = false;
                            this.isDisabled = false;
                            this.$dialog.alert({
                                title: '错误',
                                message: '验证码错误，请重新填写。',
                            });
                        }
                    } else {
                        this.$toast.clear();
                        this.checkCodeDisabled = false;
                        this.isDisabled = false;
                        this.$dialog.alert({
                            title: '错误',
                            message: checkCodeResult.AllMessages,
                        });
                    }
                    
                } else {
                    this.$toast.clear();
                    this.checkCodeDisabled = false;
                    this.isDisabled = false;
                    this.$dialog.alert({
                        title: '错误',
                        message: '照片对比失败，请重新上传照片。',
                    });
                }
            } else {
                this.$toast.clear();
                this.checkCodeDisabled = false;
                this.isDisabled = false;
                this.$dialog.alert({
                    title: '错误',
                    message: contrastResult.AllMessages,
                });
            }
        }
    }
    // 保存
    private async save() {
        // 数据查重
        const checkModel = {
            IDnumber: this.userIDCode,
        };
        const repeatResult = await this.$api.httpGet('InterFace/UworkFaceInfo/CheckUworkweight', checkModel);
        if (repeatResult.Success) {
            let addType = 0;
            if (repeatResult.Data) {
                addType = 1; // 更新
            } else {
                addType = 0; // 新增
            }
            // 保存数据
            if (!check.checkNull(this.IDCardInfo)) {
                this.$toast.clear();
                this.$dialog.alert({
                    title: '错误',
                    message: '身份证信息获取失败，请重新上传身份证正面照。',
                });
            } else if (!check.checkNull(this.IDCardBackInfo)) {
                this.$toast.clear();
                this.$dialog.alert({
                    title: '错误',
                    message: '身份证信息获取失败，请重新上传身份证反面照。',
                });
            } else if (!check.checkNull(this.LiveInfo)) {
                this.$toast.clear();
                this.$dialog.alert({
                    title: '错误',
                    message: '生活照信息获取失败，请重新拍照上传生活照。',
                });
            } else {
                // 新增/编辑
                const addInfo = {
                    model: {
                        OrganizationUserName: this.chiefInfo.organizationUserName, // 总工姓名
                        OrganizationCode: this.chiefInfo.organizationCode, // 总工机构code
                        IDFrontFileURL: this.IDCardInfo.fileUrl, // 身份证正面照URl
                        IDbackFileURL: this.IDCardBackInfo.fileUrl, // 身份证反面照URl
                        LifePhotoFileURL: this.LiveInfo.fileUrl, // 生活照URl
                        UserName: this.userName, // 填写人姓名
                        IDnumber: this.userIDCode, // 身份证号
                        PhoneNumber: this.userPhone, // 手机号
                    },
                    type: addType,
                };
                const addResult = await this.$api.httpPost('InterFace/UworkFaceInfo/AddOrUpdateUworkInfo', addInfo);
                if (addResult.Success) {
                    this.$toast.clear();
                    this.checkCodeDisabled = true;
                    this.isDisabled = true;
                    this.$toast.success('保存成功');
                    // 保存成功后跳转路径
                    if (this.reactURL === '' || this.reactURL === null || this.reactURL === undefined) {
                        // this.$router.go(-1);
                    } else {
                        window.location.replace(this.reactURL);
                    }
                } else {
                    this.$toast.clear();
                    this.checkCodeDisabled = false;
                    this.isDisabled = false;
                    this.$dialog.alert({
                        title: '保存失败',
                        message: addResult.AllMessages,
                    });
                }
            }
        } else {
            this.$toast.clear();
            this.checkCodeDisabled = false;
            this.isDisabled = false;
            this.$dialog.alert({
                title: '错误',
                message: repeatResult.AllMessages,
            });
        }
    }

}
